// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qd-9";
export var arrowButtonContainer = "_qd-5";
export var arrowButtonIcon = "_qd-6";
export var carouselArrowButton = "_qd-2";
export var carouselElementContainer = "_qd-1";
export var currentSlide = "_qd-8";
export var left = "_qd-3";
export var otherSlide = "_qd-a";
export var productCarouselContainer = "_qd-0";
export var right = "_qd-4";
export var sliderOverflow = "_qd-7";